import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { login, logout } from "../actions/authActions";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";

import Drawer from "@material-ui/core/Drawer";
import DrawerContent from "./DrawerContent";

class Navigation extends Component {
  state = {
    anchorEl: null,
    mobileOpen: false,
  };

  handleDrawerToggle = () => {
    this.setState((state) => ({ mobileOpen: !state.mobileOpen }));
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  login = () => {
    this.props.login();
  };

  logout = () => {
    this.setState({ anchorEl: null });
    this.props.logout();
  };

  render() {
    const open = Boolean(this.state.anchorEl);

    return (
      <Fragment>
        <AppBar position="static">
          <Toolbar>
            {this.props.enableGoBack &&
            document.referrer.includes(window.location.hostname) ? (
              <IconButton onClick={() => window.history.back()} color="inherit">
                <ArrowBack />
              </IconButton>
            ) : (
              <IconButton
                onClick={this.handleDrawerToggle}
                color="inherit"
                aria-label="Menu"
              >
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
              {this.props.title}
            </Typography>
            {localStorage.getItem("credentials") ? (
              <div>
                <IconButton color="inherit" onClick={this.handleMenu}>
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={this.state.anchorEl}
                  open={open}
                  onClose={this.handleClose}
                >
                  <MenuItem disabled={true}>
                    Welkom{" "}
                    {
                      JSON.parse(localStorage.getItem("credentials")).user
                        .displayName
                    }
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      window.location.href = `/my-account`;
                    }}
                  >
                    Mijn account
                  </MenuItem>
                  <Divider light />
                  <MenuItem onClick={this.logout}>Log uit</MenuItem>
                </Menu>
              </div>
            ) : (
              <Button onClick={this.login} color="inherit">
                Login
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <Drawer
          open={this.state.mobileOpen}
          onClose={this.handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <DrawerContent />
        </Drawer>
      </Fragment>
    );
  }
}

Navigation.propTypes = {
  title: PropTypes.string.isRequired,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  enableGoBack: PropTypes.bool,
};

export default connect(null, { login, logout })(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation.js